import { fetchAuthSession, signInWithRedirect } from "aws-amplify/auth";
import { getCurrentURLLocation } from "./functions";
import { ROUTE_KEYS, ROUTES } from "../_configuration/routing/constants";

export async function fetchCurrentSession() {
  try {
    const { tokens } = await fetchAuthSession();
    return tokens?.idToken?.payload;
  } catch {
    return null;
  }
}

export async function fetchCurrentIdToken() {
  try {
    const { tokens } = await fetchAuthSession();
    const idToken = tokens?.idToken?.toString();
    return idToken || "";
  } catch {
    return "";
  }
}

export function getRedirectParams(redirectPath = "") {
  let customState = redirectPath || getCurrentURLLocation();
  const loginPath = customState.startsWith(ROUTES[ROUTE_KEYS.LOGIN].path);
  const logoutPath = customState.startsWith(ROUTES[ROUTE_KEYS.LOGOUT].path);
  if (!customState || loginPath || logoutPath) {
    customState = "/";
  }

  return {
    provider: {
      custom: process.env.REACT_APP_SAML_PROVIDER,
    },
    customState,
  };
}

export async function isUserAuthenticated() {
  try {
    const currentToken = await fetchCurrentIdToken();
    return Boolean(currentToken);
  } catch (err) {
    return false;
  }
}

export function parseRoles(session) {
  let nestedTokenSession = session?.idToken?.payload || session
  const cognitoGroups = nestedTokenSession?.["cognito:groups"]
  let applicationRoles = []
  if(Array.isArray(cognitoGroups) && cognitoGroups?.length) {
    applicationRoles = cognitoGroups
  } else {
    applicationRoles = nestedTokenSession?.applicationRoles.split(",")
  }

  return applicationRoles
    .map((o) => o.trim())
    .filter(Boolean) 
    || [];
}

export async function fetchApplicationRoles() {
  try {
    const payload = await fetchCurrentSession();
    return parseRoles(payload);
  } catch (error) {
    return [];
  }
}

export async function redirectToLogIn(redirectPath = "") {
  const params = getRedirectParams(redirectPath);
  return await signInWithRedirect(params);
}
